import { MemberExperienceUserFromIdToken } from '@guildeducationinc/auth-frontend-tools';
import { trackClickedFilters, trackEvent } from '@src/services/analytics';

export const getTransformedItems = (items, ranges) => {
	const allItems = [];
	const itemsWithHits = items.map(item => item.value);

	ranges.forEach(range => {
		if (itemsWithHits.includes(range)) {
			const itemWithHits = items.find(item => item.value === range);
			const itemWithLabelCounts = {
				...itemWithHits,
				label: `${itemWithHits.label} (${itemWithHits.count})`,
			};
			allItems.push(itemWithLabelCounts);
		} else {
			allItems.push({
				label: `${range} (0)`,
				value: range,
				count: 0,
			});
		}
	});

	return allItems;
};

export const getDisabledValues = transformedItems => {
	const itemsWith0Count = transformedItems.filter(item => item.count === 0);
	const disabledValues = itemsWith0Count.map(item => item.value);
	return disabledValues;
};

export const trackFilterEvents = (
	attribute: string,
	eventName: string,
	filterCategory: string,
	facetValue: string,
	index: string,
	results: { queryID?: string },
	user: MemberExperienceUserFromIdToken
) => {
	trackEvent(eventName, {
		filterCategory,
		filterValue: [facetValue],
	});
	trackClickedFilters({
		filters: [`${attribute}:${facetValue}`],
		index,
		queryId: results.queryID,
		userUuid: user.id,
	});
};
